const mappingData = {
  mapping: 'Mapping',
  modalListPatient: {
    title: 'Matched Data Patient'
  },
  confirmSave: {
    title: 'Confirm Save',
    text: 'Do you want to save process matched data patient?'
  },
  checkConfirmSave: {
    title: 'Confirm Save Data Patient'
  },
  column: {
    mapping: 'Mapping',
    history: 'History'
  }
}
export default mappingData
